// extracted by mini-css-extract-plugin
module.exports = {"container":"fd-z","timeTop":"gd-z","timeCountdown":"hd-z","cta":"id-z","disabled":"jd-z","product":"kd-z"};